module.exports = __webpack_public_path__ + "static/media/batteryOrange.450f7d5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DevicesList/batteryOrange.svg
// module id = 99
// module chunks = 0